import { WithStyles, withStyles } from "@material-ui/core/styles";
import * as React from "react";
import Component from "../../../components/Component";
import withAxios, { IAxiosProps } from "../../../components/withAxios";
import Headerpage from "src/components/header";
import "src/pages/home/signUp-pages/style.css";
import { AppContextConsumer, IAppContext } from "src/components/withAppContext";
import { Redirect, withRouter } from 'react-router-dom';
import Footerpage from "src/components/footer";

const styles = () => ({
  childTemplate: {
    paddingLeft: 80,
  },
  listItem: {
    "&:hover": {
      backgroundColor: "#e6e6e6",
    },
    backgroundColor: "white",
  },
});

type IProps = IAxiosProps & IAppContext & WithStyles<keyof ReturnType<typeof styles>> & { history: any };

interface ITemplatesPageState {
  schoolOrganization: string;
  schoolOrganizationErr: string;
  loader: boolean;
  redirect: boolean;
  activeContainer: number | null;
  schoolType: any,
  schoolTypeErr:string
}


const Home = withStyles(styles)(



  
  withAxios(
    class SignUpStepTwo extends Component<IProps, ITemplatesPageState> {
      public state = {
        schoolOrganization: '',
        schoolOrganizationErr: '',
        loader: false,
        redirect: false,
        activeContainer: null,
        schoolType: "",
        schoolTypeErr:""
      };
      public componentWillMount() {
        this.props.getNewLoginUserDetails()
      }
      public componentDidMount() {
        this.setState({ redirect: false });
        window.scrollTo({ top: 0, behavior: 'smooth' });
        if (this.props?.newUserDetails?.schoolOrganization) {
          this.setState({ schoolOrganization: this.props.newUserDetails.schoolOrganization });
        }
        if (this.props?.newUserDetails?.schoolType) {
          this.setState({ schoolType: this.props?.newUserDetails?.schoolType })
        }
      }
      

      public toggleContainer = (containerId: any) => {
        this.setState({
          schoolType: containerId
        });
      };

      public nextHandler = () => {
        this.setState({ schoolOrganizationErr: '',schoolTypeErr:"" });
        const { schoolOrganization,schoolType } = this.state;
        if (schoolOrganization !== ""&&schoolType!=="") {
          this.props.onChangeUserDetails({
            ...this.props?.newUserDetails,
            schoolOrganization,
            schoolType
          });
          // this.setState({ redirect: true });
          this.props.history.push("/lead")
        } else {
          if(schoolOrganization===""){

            this.setState({ schoolOrganizationErr: 'School organization is required' });
          }
          if(schoolType===""){
            this.setState({ schoolTypeErr: 'School type is required' });
          }
        }
      };

      public render() {
      
        return (
          <>
            {this.state.redirect && <Redirect to="/lead" />}
            <div className="school-page-inner">
           <Headerpage/>
            <div className="container-inner">
              <div
                className="content-leader"
                style={{
                  width: "100%",
                  height: "calc(100vh - 153px)",
                  backgroundImage: `-webkit-gradient(linear, left top, left bottom, from(rgba(62, 124, 177, 0.5)), to(rgba(62, 124, 177, 0.5))), url(${require('src/assets/gritp.jpg')})`,
                }}
              >
                <div className="welcome-backs">
                  <div className="sign-In-backs school-inner">
                    <h1>{this.props?.newUserDetails?.firstName?.trim()},{" "}what school do you lead?</h1>
                    <form className="next2-form">
                      <div className="input-flex">
                        <div className="col-lg-8 col-md-12 col-sm-12">
                          <input
                            type="text"
                            className="form-control input-school"
                            placeholder="School name (please do not abbreviate)"
                            value={this.state.schoolOrganization}
                            onChange={(event) => {
                              this.setState({ schoolOrganization: event.target.value });
                            }}
                          />
                          {this.state.schoolOrganizationErr && (
                            <div className="span-error" style={{ color: 'red' }}>
                              {this.state.schoolOrganizationErr}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="btn-flex">
                        <div
                          onClick={() => {
          
                            this.toggleContainer('middle_school')
                          }}
                        >
                          <div
                            className={this.state.schoolType==="middle_school"?"middle-high border-high border-middle":"middle-high activenone border-high"} ><label>Middle School</label></div>
                        </div>
                        <div
                          onClick={() => {
                            this.toggleContainer('high_school')
                          }}
                        >
                          <div
                            className={this.state.schoolType==="high_school"?"middle-high border-high border-middle":"middle-high activenone border-high"}><label>High School</label></div>
                        </div>
                      </div>
                      {this.state.schoolTypeErr && (
                            <div className="span-error highschool-error" style={{ color: 'red' }}>
                              {this.state.schoolTypeErr}
                            </div>
                          )}
                    </form>
                    <button
                      className="sign-btn"
                      onClick={this.nextHandler}
                    >
                      <span className="next-span-btn">NEXT</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          <Footerpage/>
            </div>
          </>
        );
      }
    }
  )
);

const HomeFunction = (props: any) => (
  <AppContextConsumer>{(context) => <Home {...context} history={props?.history} />}</AppContextConsumer>
);

export default withRouter(HomeFunction);


// WEBPACK FOOTER //
// ./src/pages/home/school/school.tsx